import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { IconButtonComponent } from '../button';
import { IconComponent } from '../icon';
import { ProgressBarComponent, ProgressBarModel } from '../progress-bar/progress-bar.component';
import { LegacyChecklistItemComponent } from './checklist-item/checklist-item.component';
import { CheckListAction, ChecklistItemModel } from './checklist.model';

/**
 * @deprecated This component will be removed in future versions. Please use ChecklistComponent instead.
 */
@Component({
  selector: 'sb-legacy-checklist',
  standalone: true,
  imports: [CommonModule, IconComponent, IconButtonComponent, LegacyChecklistItemComponent, ProgressBarComponent],
  templateUrl: './checklist.component.html',
})
export class LegacyChecklistComponent {
  @HostBinding('class')
  public baseClass = 'absolute bottom-20 z-50';

  @Input()
  public title!: string;
  @Input()
  public subtitle!: string;
  @Input()
  public progress!: ProgressBarModel;
  @Input()
  public items!: ChecklistItemModel[];
  @Output()
  public closed = new EventEmitter<void>();
  @Output()
  public minimized = new EventEmitter<void>();

  public onMinimize() {
    this.minimized.emit();
  }

  public onClose() {
    this.closed.emit();
  }

  public onItemClick(action?: CheckListAction) {
    if (!action) {
      return;
    }
    action();
  }
}
